export default "icons-instagram-filled"